module.exports = __webpack_public_path__ + "img/20_Minutes_logo.237cc902.svg";